import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetContextDocumentUsage as GetContextDocumentUsageQuery} from 'nutshell-graphql-types';

import GET_CONTEXT_DOCUMENT_USAGE from '../queries/get-context-document-usage.graphql';

export const useGetContextDocumentUsage = () => {
    const {data, loading, error, refetch} = useQuery<
        GetContextDocumentUsageQuery,
        Record<any, any>
    >(GET_CONTEXT_DOCUMENT_USAGE, {
        fetchPolicy: 'cache-and-network',
    });

    const contextDocumentUsage = data ? data.contextDocumentUsage : null;

    return {
        contextDocumentUsage,
        hasNoContent: contextDocumentUsage ? contextDocumentUsage.wordsUsage === 0 : true,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
        refetch,
    };
};
